import type {WidgetFragment as Widget} from 'nutshell-graphql-types';

import {CustomFieldsWidget as CoreCustomFieldsWidget} from '../../../core-entity/widgets/custom-fields-widget/components/custom-fields-widget';

import {useLeadCustomFieldHandlers} from '../../shared/hooks';

interface Props {
    leadId: string;
    widget: Widget;
}

export function LeadCustomFieldsWidget(props: Props) {
    const handlers = useLeadCustomFieldHandlers(props.leadId);

    return (
        <CoreCustomFieldsWidget
            entityId={props.leadId}
            widget={props.widget}
            handlers={handlers}
            emptyStateKey='leadCustomFields'
        />
    );
}
